var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.shouldShowIcons
    ? _c("div", { staticClass: "flex flex-col justify-left py-2" }, [
        _c(
          "div",
          {
            staticClass:
              "flex items-center gap-6 bg-white border border-gray-200 rounded-lg p-3 shadow-sm",
          },
          [
            _vm.hasTransportationType("driving")
              ? _c("div", { staticClass: "flex flex-col items-center gap-1" }, [
                  _c(
                    "svg",
                    {
                      class: _vm.getIconColorClasses("driving"),
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
                        },
                      }),
                      _c("circle", { attrs: { cx: "7", cy: "17", r: "2" } }),
                      _c("path", { attrs: { d: "M9 17h6" } }),
                      _c("circle", { attrs: { cx: "17", cy: "17", r: "2" } }),
                    ]
                  ),
                  _vm.shouldShowTravelTimes && _vm.getTravelTime("driving")
                    ? _c(
                        "span",
                        {
                          staticClass: "text-sm",
                          class:
                            _vm.hasOverlappingVisit ||
                            _vm.hasConflict("driving")
                              ? "text-red-600"
                              : "text-gray-700",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getTravelTime("driving")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.hasTransportationType("public transit")
              ? _c("div", { staticClass: "flex flex-col items-center gap-1" }, [
                  _c(
                    "svg",
                    {
                      class: _vm.getIconColorClasses("public transit"),
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("path", { attrs: { d: "M8 6v6" } }),
                      _c("path", { attrs: { d: "M15 6v6" } }),
                      _c("path", { attrs: { d: "M2 12h19.6" } }),
                      _c("path", {
                        attrs: {
                          d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
                        },
                      }),
                      _c("circle", { attrs: { cx: "7", cy: "18", r: "2" } }),
                      _c("path", { attrs: { d: "M9 18h5" } }),
                      _c("circle", { attrs: { cx: "16", cy: "18", r: "2" } }),
                    ]
                  ),
                  _vm.shouldShowTravelTimes && _vm.getTravelTime("transit")
                    ? _c(
                        "span",
                        {
                          staticClass: "text-sm",
                          class:
                            _vm.hasOverlappingVisit ||
                            _vm.hasConflict("public transit")
                              ? "text-red-600"
                              : "text-gray-700",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getTravelTime("transit")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.hasTransportationType("cycling")
              ? _c("div", { staticClass: "flex flex-col items-center gap-1" }, [
                  _c(
                    "svg",
                    {
                      class: _vm.getIconColorClasses("cycling"),
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18.5", cy: "17.5", r: "3.5" },
                      }),
                      _c("circle", {
                        attrs: { cx: "5.5", cy: "17.5", r: "3.5" },
                      }),
                      _c("circle", { attrs: { cx: "15", cy: "5", r: "1" } }),
                      _c("path", {
                        attrs: { d: "M12 17.5V14l-3-3 4-3 2 3h2" },
                      }),
                    ]
                  ),
                  _vm.shouldShowTravelTimes && _vm.getTravelTime("bicycling")
                    ? _c(
                        "span",
                        {
                          staticClass: "text-sm",
                          class:
                            _vm.hasOverlappingVisit ||
                            _vm.hasConflict("cycling")
                              ? "text-red-600"
                              : "text-gray-700",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getTravelTime("bicycling")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.hasTransportationType("walking")
              ? _c("div", { staticClass: "flex flex-col items-center gap-1" }, [
                  _c(
                    "svg",
                    {
                      class: _vm.getIconColorClasses("walking"),
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("circle", { attrs: { cx: "12", cy: "5", r: "1" } }),
                      _c("path", { attrs: { d: "m9 20 3-6 3 6" } }),
                      _c("path", { attrs: { d: "m6 8 6 2 6-2" } }),
                      _c("path", { attrs: { d: "M12 10v4" } }),
                    ]
                  ),
                  _vm.shouldShowTravelTimes && _vm.getTravelTime("walking")
                    ? _c(
                        "span",
                        {
                          staticClass: "text-sm",
                          class:
                            _vm.hasOverlappingVisit ||
                            _vm.hasConflict("walking")
                              ? "text-red-600"
                              : "text-gray-700",
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.getTravelTime("walking")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }